import gql from 'graphql-tag';

const logEventMutation = gql`
  mutation LogEvent($organisationId: String!, $type: String!) {
    logEvent(organisationId: $organisationId, type: $type)
  }
`;

export default (() => ({
  mutation: logEventMutation,
  module: 'articles',
  buildVariables: (params) => params
}));